export default __webpack_public_path__ + "static/media/DNo.37-3.d1931cbe.jpg";